<template>
	<div class="container">
		<b-modal hide-footer id="modal-1" size="lg">
			<p class="encabezado text-center">Envío de facturas a:</p>
			<div class="container">
				<div class="table-wrapper-scroll-y my-custom-scrollbar">
					<table style="width:100%">
						<tr :key="correo.id" v-for="correo in correos">
							<td class="textAzul d-flex justify-content-between">
								{{correo.correo}}
								<i
									@click="modalEliminar(correo.correo)"
									class="icon-trazado-1162 cursor-pointer"
								></i>
							</td>
							<hr />
						</tr>
					</table>
				</div>
				<hr />
				<div class="d-flex justify-content-center mt-4">
					<input
						:class="{ 'is-invalid': $v.email.$error }"
						@keyup.enter="agregarCorreo"
						class="form-control textt"
						placeholder="Agregar otro correo adicional"
						ref="email"
						type="email"
						v-model="$v.email.$model"
					/>

					<button @click="agregarCorreo" class="ButtonAgregar">Agregar</button>
				</div>
			</div>
			<div class="d-flex justify-content-center">
				<div class="container row">
					<div class="col-sm-12 col-md-6">
						<b-button @click="$bvModal.hide('modal-1')" block class="m-3 Button">Cancelar</b-button>
					</div>
					<div class="col-sm-12 col-md-6">
						<b-button @click="enviarCorreoFacturas" block class="m-3 Button">Enviar</b-button>
					</div>
				</div>
			</div>
		</b-modal>

		<b-modal hide-footer id="modal-2" size="sm">
			<p class="text-center">Desea eliminar el correo:</p>
			<div class="d-flex justify-content-center textEliminar">{{correoEliminar}}</div>
			<div class="d-flex justify-content-center">
				<Button @click="$bvModal.hide('modal-2')" block class="m-3 btn btn-secondary">Cancelar</Button>
				<Button @click="eliminarCorreo" block class="m-3 btn btn-primary">Eliminar</Button>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import servicioFacturas from "@/services/servicio-facturas"
	import Swal from "sweetalert2"
	import { required, email } from "vuelidate/lib/validators"

	export default {
		props: ["correos", "facturas"],
		data() {
			return {
				correoAgregar: null,
				correoEliminar: null,
				email: null
			}
		},
		validations: {
			email: {
				required,
				email
			}
		},
		updated() {
			this.$refs.email.focus()
		},
		methods: {
			modalEliminar(correo) {
				this.correoEliminar = correo
				this.$bvModal.show("modal-2")
			},
			enviarCorreoFacturas() {
				servicioFacturas
					.enviarPorCorreo(this.facturas, this.correos)
					.then(r => {
						console.log(r)
						if (r.value) {
							Swal.fire({
								text: r.message,
								icon: "success"
							})
							this.$bvModal.hide("modal-1")
						} else {
							Swal.fire({
								text: r.message,
								icon: "warning"
							})
						}
					})
					.catch(ex => {
						Swal.fire({
							text: ex.message,
							icon: "error"
						})
					})
			},
			eliminarCorreo() {
				this.$emit("eliminarCorreo", this.correoEliminar)
				this.$bvModal.hide("modal-2")
				this.$refs.email.focus()
			},
			agregarCorreo() {
				console.log(this.email)

				this.$v.$touch()

				if (this.$v.email.$error || !this.email) {
					this.$refs.email.focus()
				} else {
					this.$emit("agregarCorreo", this.email)
					this.email = null
					this.$v.$reset()
					this.$refs.email.focus()
				}
			}
		}
	}
</script>
<style scoped>
	.cursor-pointer {
		cursor: pointer;
	}
	.textt {
		width: 300px;
		background: silver;
		color: var(--bg-menu-blue);
		border: 1px solid var(--bg-menu-blue);
		border-radius: 0%;
	}
	.my-custom-scrollbar {
		position: relative;
		height: 150px;
		overflow: auto;
	}
	.table-wrapper-scroll-y {
		display: block;
	}
	.textEliminar {
		color: var(--bg-menu-blue);
		font-weight: bold;
	}
	.textAzul {
		color: var(--bg-menu-blue);
	}
	.encabezado {
		background: var(--bg-menu-blue);
		color: white;
		font-size: 20px;
	}
	.ButtonAgregar {
		width: 20%;
		background: var(--bg-menu-blue);
		color: white;
		border: none;
	}
	.Button {
		width: 100%;
		background: var(--bg-menu-blue);
		color: white;
	}
	.Button:hover {
		background-color: var(--color-font-blue);
	}
</style>